/**
 * Deep links into the care note surface.
 *
 * `/patients/:patientId/care-note/:memberFormId` already links to an existing note.
 * Starting a *new* one had no URL of its own -- it was only reachable by pressing
 * "Add Care Note" in the grid header -- so this flag lets other parts of the app send
 * a clinician straight into the Add drawer. CareNoteGrid consumes the flag and strips
 * it from the URL once open. `form` picks the care note type (a clinical form id);
 * without it the drawer opens on the "Appointment" type.
 */

export const NEW_CARE_NOTE_PARAM = "new";

/** The "Care Management" care note (clinical-forms-adaptor CareManagementCareNote1758737163000). */
export const CARE_MANAGEMENT_FORM_ID = "cc3c2e0d-4983-430a-b34e-56a8e13a97a4";
export const NEW_CARE_NOTE_FORM_PARAM = "form";

export const careNotesPathFor = (patientId: string) =>
  `/patients/${patientId}/care-note`;

export const newCareNotePath = (patientId: string, formId?: string) =>
  `${careNotesPathFor(patientId)}?${NEW_CARE_NOTE_PARAM}=1${
    formId ? `&${NEW_CARE_NOTE_FORM_PARAM}=${encodeURIComponent(formId)}` : ""
  }`;
